'use client';
import React, { useMemo } from 'react';
import sanitizeHtml from 'sanitize-html';

const DEFAULT_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'a',
  'span',
  'div',
] as const;

const DEFAULT_ALLOWED_ATTRIBUTES = ['href', 'target', 'rel', 'class', 'id', 'style'] as const;

/** Copias fijas para defaults estables en useMemo */
const DEFAULT_TAGS_LIST: string[] = [...DEFAULT_ALLOWED_TAGS];
const DEFAULT_ATTRS_LIST: string[] = [...DEFAULT_ALLOWED_ATTRIBUTES];

interface SafeHtmlProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
  allowedTags?: string[];
  allowedAttributes?: string[];
}

const SafeHtml: React.FC<SafeHtmlProps> = ({
  html,
  className = '',
  style,
  allowedTags: allowedTagsProp,
  allowedAttributes: allowedAttributesProp,
}) => {
  const allowedTags = allowedTagsProp ?? DEFAULT_TAGS_LIST;
  const allowedAttributes = allowedAttributesProp ?? DEFAULT_ATTRS_LIST;

  const sanitizedHtml = useMemo(() => {
    const dirty = html == null ? '' : String(html);
    return sanitizeHtml(dirty, {
      allowedTags,
      allowedAttributes: {
        '*': allowedAttributes,
      },
      allowedStyles: {
        a: {
          'text-decoration': [/^underline$/],
        },
      },
      allowedSchemes: ['http', 'https', 'mailto', 'tel'],
      allowProtocolRelative: false,
    });
  }, [html, allowedTags, allowedAttributes]);

  return (
    <div data-component-id="src/components/ui/SafeHtml.tsx:69:4" data-component-path="src/components/ui/SafeHtml.tsx" data-component-line="69" data-component-file="SafeHtml.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className} style={style} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default SafeHtml;
